import React, { useState } from "react";
import { 
    Flex, 
    Table, 
    TableContainer, 
    Tbody, 
    Td, 
    Th, 
    Thead, 
    Tr,
    Button, 
    Tooltip,
    Text,
    Spinner,
} from "@chakra-ui/react";
import { IoEye, IoEyeOff, IoShare } from "react-icons/io5";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useSelector } from "react-redux";

const StoresTable = ({
    stores,
    loading,
    error,
    currentPage,
    totalPages,
    page,
    setPage,
    toggleStoreActive,
}) => {
    const [operationLoading, setOperationLoading] = useState(false);
    const userInfo = useSelector((state) => state.userLogin.userInfo);

    const formatDate = (date) => {
        const newDate = new Date(date);
        const day = newDate.getDate();
        const month = newDate.getMonth() + 1;
        const year = newDate.getFullYear();
        return `${day}/${month}/${year}`;
    }

    if(loading) return (
        <Flex
            mt='20px'
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
        >   
            <Spinner />
        </Flex>
    )

    if(error) return (
        <Flex
            mt='20px'
            w="100%"
            h="100%"
            justifyContent="center"
            alignItems="center"
            flexDir='column'
        >   
            <Text>Algo salió mal, inténtalo más tarde.</Text>
        </Flex>
    )

    return (
    <Flex
        w="100%"
        flexDir='column'
        alignItems='end'
    >
        <TableContainer
            w="100%"
            maxW="100%"
            h="100%"
            maxH="100%"
            overflow="auto"
        >
            <Table 
                size="sm"
                variant="striped"
                colorScheme='facebook'
            >
                <Thead>
                    <Tr>
                        <Th>Nombre</Th>
                        <Th>Creador</Th>
                        <Th>Creación</Th>
                        <Th>Productos</Th>
                        <Th>Acciones</Th>
                    </Tr>
                </Thead>
                <Tbody>
                {stores.map((store) => (
                    <Tr key={store._id}>
                        <Td>{store.name}</Td>
                        <Td>{store.user.email}</Td>
                        <Td>{formatDate(store.createdAt)}</Td>
                        <Td>{store.products.length} / {userInfo.productsSlots || 0}</Td>
                        <Td>
                            <Flex
                                justifyContent='flex-start'
                                alignItems='center'
                            >
                                <Tooltip 
                                    label={store.active ? 'Desactivar' : 'Activar'}
                                    aria-label={store.active ? 'Desactivar' : 'Activar'}
                                >
                                    <Button
                                        size='sm'
                                        colorScheme='blue'
                                        variant='outline'
                                        borderRadius='50%'
                                        p='5px'
                                        isLoading={operationLoading}
                                        onClick={() => toggleStoreActive(store._id, setOperationLoading)}
                                    >
                                        {
                                            store.active ?
                                            <IoEye /> : <IoEyeOff />
                                        }
                                    </Button>
                                </Tooltip>
                                <Tooltip label='Abrir en nueva pestaña' aria-label='Abrir en nueva pestaña'>
                                    <Button
                                        size='sm'
                                        colorScheme='green'
                                        variant='outline'
                                        borderRadius='50%'
                                        p='5px'
                                        ml='5px'
                                        isLoading={operationLoading}
                                        onClick={() => window.open(`${process.env.REACT_APP_WEB}/${store.shortName}`, "_blank")}
                                    >
                                        <IoShare />
                                    </Button>
                                </Tooltip>
                            </Flex>
                        </Td>
                    </Tr>
                ))}
                </Tbody>
            </Table>
            <Flex
                w='100%'
                justifyContent='space-between'
                alignItems='baseline'
            >
                <Flex
                    mt='20px'
                    justifyContent='start'
                    alignItems='baseline'
                >
                    <Button
                        fontSize={'.9rem'}
                        mr='5px'
                        size='xs'
                        colorScheme='blue'
                        variant='outline'
                        disabled={currentPage === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        <MdChevronLeft />
                    </Button>
                    <Button
                        fontSize={'.9rem'}
                        mr='10px'
                        size='xs'
                        colorScheme='blue'
                        variant='outline'
                        disabled={currentPage === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        <MdChevronRight />
                    </Button>
                    <Text
                        mt='20px'
                        fontSize='.9rem'
                    >
                        Pág. {currentPage} de {totalPages}
                    </Text>
                </Flex>
            </Flex>
        </TableContainer>
    </Flex>
    );
}

export default StoresTable;